import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { CommonService } from '../../../_common/_service/user.service';

@Component({
  selector: 'app-refunds',
  templateUrl: './refunds.component.html',
  styleUrls: ['./refunds.component.scss']
})
export class RefundsComponent implements OnInit {

  token: any;
  constructor(private tokenStorageService: TokenStorageService, private _service: CommonService, private router: Router) { }

  ngOnInit() {
    this.token = this.tokenStorageService.getToken();
  }

  Back() {

    this.router.navigate(['/Go-on']);
  }
}
